import { useMutation } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'

export const useRequestCommissionMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: requestCommissionMutation } = useMutation({
		mutationFn: ({ checkedSales }: { checkedSales: number[] }) => {
			return axiosPrivate.post(apiRoutes.salesRecalculateCommission, { ids: checkedSales })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Recalculating commissions succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		requestCommissionMutation
	}
}
